import { Grid as MuiGrid } from '@mui/material';

import { BasetenPageEnum } from '@/routes';

import GridCardWrapper from '../../sections/GridCardWrapper';
import { GridContainer } from '../../styled';
import { ListProps } from '../types';
import Card from './Card';

function Grid({ trainingProjects }: ListProps) {
  return (
    <GridContainer px={4} py={2}>
      <MuiGrid container spacing={3}>
        {trainingProjects.map((trainingProject) => (
          <GridCardWrapper<BasetenPageEnum.TrainingProject>
            linkParams={{
              page: BasetenPageEnum.TrainingProject,
              params: { trainingProjectId: trainingProject.id },
            }}
            key={trainingProject.id}
            alwaysVisible={trainingProjects.length < 35}
          >
            <Card trainingProject={trainingProject} />
          </GridCardWrapper>
        ))}
      </MuiGrid>
    </GridContainer>
  );
}

export default Grid;
